import { Dropdown } from "primereact/dropdown"
import { useTaskAnalysis } from "../../Hooks/Features/ProjectGlance/useTaskAnalysis";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import DatePicker from "react-multi-date-picker";
import { SkeletonContainer } from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CreatedVsResolved = ({ projectId }) => {

    const tab = "created_vs_resolved";
    const { createdVsResolvedOptions, filterValues, setFilterValues, opts, getCreatedVsResolved, loader } = useTaskAnalysis({ projectId, tab });

    return (
        <div className="h-100">
            <div className="d-flex align-items-center justify-content-between">
                <div className="fs-6 fw-semibold"><FontAwesomeIcon icon="fa-solid fa-chart-line" /> Created vs Resolved</div>
                <div className="d-flex w25 gap-3 justify-content-end align-items-center">
                    <div>
                        <DatePicker placeholder="Select Date Range" range rangeHover value={filterValues?.date} onChange={(e) => setFilterValues((prev) => ({ ...prev, date: e, is_change: true }))} onClose={() => { if (filterValues?.is_change) { getCreatedVsResolved(); } }} />
                    </div>
                    <div className="w35">
                        <Dropdown className="input-dd w100" placeholder="Category" optionLabel="frequency_type_name" optionValue="frequency_type_key" options={opts?.frequency_type} value={filterValues?.frequency_type} onChange={(e) => setFilterValues((prev) => ({ ...prev, frequency_type: e.target?.value, is_change: true }))} onHide={() => { if (filterValues?.is_change) { getCreatedVsResolved(); } }} />
                    </div>
                </div>
            </div>
            <div style={{ height: "90%" }}>
                {loader ? <div className="h-100"><SkeletonContainer /></div> :
                    <HighchartsReact highcharts={Highcharts} options={createdVsResolvedOptions} containerProps={{ style: { height: "100%" } }} />}
            </div>
        </div>
    )
}

export default CreatedVsResolved